import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=c30ce332&scoped=true"
import script from "./FloatingChat.vue?vue&type=script&lang=js"
export * from "./FloatingChat.vue?vue&type=script&lang=js"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=c30ce332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30ce332",
  null
  
)

export default component.exports